<ion-row>
  <ion-col size="12">
    <ion-list>
      <ng-container *ngIf="option?.is_multiple;else single">

        <ion-item lines="none" *ngFor="let opt of option?.options">
          <ion-label>
            <h5>{{opt | caption}}</h5>
          </ion-label>
          <ion-checkbox (ionChange)="selectedOptionsChanged(opt,'multiple')" slot="end" value="{{opt}}"></ion-checkbox>
        </ion-item>

      </ng-container>
      <ng-template #single>


        <ion-radio-group value="{{option?.options[0]}}">
          <ion-item lines="none" *ngFor="let opt of option?.options">
            <ion-label>
              <h5>{{opt | caption}}</h5>
            </ion-label>
            <ion-radio (click)="selectedOptionsChanged(opt,'single')" color="primary" slot="start" value="{{opt}}">
            </ion-radio>
          </ion-item>
        </ion-radio-group>

      </ng-template>
    </ion-list>
  </ion-col>

</ion-row>